const state = {
  islandProgression: {},
  thematics: {},
  thematicsByLevel: {},
  lesson: {},
  teachbotLesson: {},
  evaluateLesson: {},
  expression: {},
  expressions: {},
  expressionsAll: {
    unknown: [],
    passive: [],
    active: [],
  },
  expressionsNext: {},
  expressionTags: {},
  weeklyLessons: {},
  currentlyLoadedIslandWhereUserWas: '',
  currentlyLoadedIslandLevel: undefined,
  text: '',
  botmsg: {},
  translation: '',
  transcribedText: '',
  teachbotGroups: [],
  grammarGroups: [],
  lessonInfo: {},
  catalog: {
    categories: [],
  },
  favouritedExpressionIds: {},
  languageCollison: false,
  sendedLanguageCollisonHeader: false,
  isClassLanguageCollison: false,
};

export default state;
